import { dashboardComponent } from './dashboard.component';
import { DashboardService } from './dashboard.service';
import './dashboard.scss';

export const dashboard = angular
     .module('components.dashboard', [])
     .component('dashboard', dashboardComponent)
     .config(($stateProvider) => {
     	'ngInject';

     	$stateProvider
		.state('app.dashboard', {
            url: 'dashboard',
            parentState: 'dashboard',
            breadcrumbName: 'dashboard',
			component: 'dashboard',
            name: 'dashboard',
            resolve: {
                list(DashboardService) {
                    'ngInject';

                    return DashboardService.getMenuList();
                }
            }
		});
     })
     .service('DashboardService', DashboardService)
     .name;


// WEBPACK FOOTER //
// ./src/app/components/dashboard/dashboard.module.js